
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { handleError, initClient } from '../../../api';
import { AccountApiClient, AccountSelect, GeneralUserSettings, SettingsApiControllerUIClient, TreeNode } from '../../backend/backendapi';
import { fixISettings } from '../../../util';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../../util/vue-good-table';
import { Like } from '../../../util/Like';

@Component({
  components: {
    VueGoodTable,
  },
})
export default class AccountsOfInterestEditor extends Vue {
  private readonly accountApi = initClient(AccountApiClient);
  private readonly settingsApi = initClient(SettingsApiControllerUIClient);

  accountSelect: AccountSelect | null = null;
  generalUserSettings: GeneralUserSettings | null = null;

  newAccountId: number | null = null;

  get accountsById(): Map<number, TreeNode> {
    return new Map((this.accountSelect?.parentList ?? []).map(e => [e.dbId!, e]));
  }

  get columnsConfig(): any[] {
    return [
      {
        label: this.$t('txtAccount').toString(),
        field: (e: TreeNode) => (e.path ?? '') + (e.text ?? ''),
      },
      {
        label: this.$t('general.actions').toString(),
        field: 'actions',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get rows(): TreeNode[] {
    return (this.generalUserSettings?.accountIdsOfInterest ?? [])
        .map((accountId: number) => this.accountsById.get(accountId) ?? TreeNode.fromJS({ dbId: accountId, text: '?', path: '?' }));
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  mounted(): void {
    fixISettings();
    this.reload();
  }

  async reload(): Promise<void> {
    //reset first
    this.accountSelect = null;
    this.generalUserSettings = null;

    //load
    const set = (await this.settingsApi.get('GeneralUserSettings', false, false)).result!;
    this.generalUserSettings = new GeneralUserSettings();
    this.generalUserSettings.init(set);

    this.accountSelect = await this.accountApi.getAccountSelect(undefined);
  }

  addAccount(): void {
    if (!this.generalUserSettings) {
      return;
    }
    if (this.newAccountId === null) {
      return;
    }
    this.generalUserSettings.accountIdsOfInterest ??= [];
    this.generalUserSettings.accountIdsOfInterest.push(this.newAccountId);

    this.newAccountId = null;
  }

  removeAccount(row: Like<TreeNode>): void {
    if (!this.generalUserSettings) {
      return;
    }
    this.generalUserSettings.accountIdsOfInterest = this.generalUserSettings.accountIdsOfInterest?.filter(e => e !== row.dbId) ?? [];
  }

  async save(): Promise<void> {
    if (!this.generalUserSettings) {
      return;
    }

    try {
      await this.settingsApi.update('GeneralUserSettings', false, false, JSON.stringify(this.generalUserSettings));
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
      throw new Error();
    }
  }
}
